import { NEW_TEST_WORDS } from '../constants/newtestament'
import { localeAwareUpperCase } from './words'

export type PracticeWord = {
  solution: string
  hint: string
  hintUrl: string
  verse: string
  verseUrl: string
  verseText: string
}

export const getRandomWord = (): PracticeWord => {
  const randomIndex = Math.floor(Math.random() * NEW_TEST_WORDS.length)
  const entry = NEW_TEST_WORDS[randomIndex]
  return {
    solution: localeAwareUpperCase(entry.word),
    hint: entry.hint,
    hintUrl: entry.hintUrl,
    verse: entry.verse,
    verseUrl: entry.verseUrl,
    verseText: entry.verseText,
  }
}

let currentWord: PracticeWord = getRandomWord()

export const getCurrentWord = () => currentWord

export const setNewRandomWord = () => {
  currentWord = getRandomWord()
  return currentWord
}

export const isWinningWord = (word: string) => {
  return currentWord.solution === word
}
